<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>产测账号设置</span>
                </div>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addDislogShow" v-if="roleCheck('106-101-101-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="password" label="账号" width="220"></el-table-column>
                <el-table-column prop="prj_name" label="项目名称"></el-table-column>
                <el-table-column prop="pcba" label="PCBA版本"></el-table-column>
                <el-table-column prop="machine" label="整机版本"></el-table-column>
                <el-table-column prop="hw_ver" label="硬件版本"></el-table-column>
                <el-table-column prop="create_time" label="创建日期"></el-table-column>
                <el-table-column prop="permission" label="权限"></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateDislogShow(scope.row)" v-if="roleCheck('106-101-101-102')">编辑</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Gh-Dialog ref="ptAccountSetting" size="big" :title="dialog.title" @dialogBack="settingConfirm">
                <template v-slot:content>
                    <el-form label-width="120px" :model="actData" ref="addProductRule">
                        <el-form-item label="账号" prop="pwd">
                            <el-input v-model="actData.pwd" placeholder="请输入账号"></el-input>
                        </el-form-item>
                        <el-form-item label="项目名称" prop="prj_name">
                            <el-input v-model="actData.prj_name" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="设备类型" prop="dev_type">
                            <el-input v-model="actData.dev_type" type="number" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="硬件版本" prop="hw_ver">
                            <el-input v-model="actData.hw_ver" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="文件系统版本" prop="fw_ver">
                            <el-input v-model="actData.fw_ver" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="固件版本" prop="fs_ver">
                            <el-input v-model="actData.fs_ver" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="厂测配置版本" prop="fctry_cfg_ver">
                            <el-input v-model="actData.fctry_cfg_ver" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="PCBA版本" prop="pcba">
                            <el-input v-model="actData.pcba" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="整机版本" prop="machine">
                            <el-input v-model="actData.machine" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="PCBA模式开关" prop="pcba_acc">
                            <el-switch v-model="actData.pcba_acc"></el-switch>
                        </el-form-item>
                        <el-form-item label="组装工厂权限" prop="fctry_acc">
                            <el-switch v-model="actData.fctry_acc"></el-switch>
                        </el-form-item>
                        <el-form-item label="维修模式权限" prop="service_acc">
                            <el-switch v-model="actData.service_acc"></el-switch>
                        </el-form-item>
                        <el-form-item label="权限" prop="permission">
                            <el-checkbox-group v-model="permission">
                                <el-checkbox label="1">猫砂盆产测</el-checkbox>
                                <el-checkbox label="4">猫砂盆维修</el-checkbox>
                                <el-checkbox label="3">猫砂盆代理商产测</el-checkbox>
                                <el-checkbox label="2">S1产测</el-checkbox>
                                <el-checkbox label="9">称重系统</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="组装工厂参数" prop="fctry_param">
                            <el-input type="textarea" v-model="actData.fctry_param" placeholder="JSON格式"></el-input>
                        </el-form-item>
                        <el-form-item label="PCBA参数" prop="pcba_param">
                            <el-input type="textarea" v-model="actData.pcba_param" placeholder="JSON格式"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark">
                            <el-input type="textarea" v-model="actData.remark" placeholder=""></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'pt-account-setting',
    data() {
        return {
            searchData: {
                page: 1,
                page_size: 10
            },
            permission: [],
            dialog: {},
            actData: {},
            accountData: [],
            listData: []
        }
    },
    watch: {
       
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.api.ptAccountList({}).then(data => {
                this.accountData = data.data;
                const defaultArr = this.accountData.filter(item => item.password == 'genhigh_default');
                const filterArr = this.accountData.filter(item => item.password != 'genhigh_default');
                const sortArr = filterArr.sort((a,b) => {
                    return a.permission.split(',')[0] - b.permission.split(',')[0];
                })
                this.listData = [...defaultArr, ...sortArr];
            })
        },
        addDislogShow() {
            this.dialog = {
                title: '新增账号',
                type: 'add'
            };
            this.actData = {
                pwd: '',
                prj_name: '',
                dev_type: 0,
                hw_ver: '',
                fw_ver: '',
                fs_ver: '',
                fctry_cfg_ver: '',
                pcba: '',
                machine: '',
                pcba_acc: false,
                fctry_acc: false,
                service_acc: false,
                fctry_param: '',
                pcba_param: '',
                remark: ''
            };
            this.permission = [];
            this.$refs.ptAccountSetting.show = true;
        },
        updateDislogShow(item) {
            this.dialog = {
                title: '修改账号',
                type: 'update'
            };
            this.actData = {
                id: item.Id,
                pwd: item.password,
                prj_name: item.prj_name || '',
                dev_type: item.dev_type || 0,
                hw_ver: item.hw_ver || '',
                fw_ver: item.fw_ver || '',
                fs_ver: item.fs_ver || '',
                fctry_cfg_ver: item.fctry_cfg_ver || '',
                pcba: item.pcba || '',
                machine: item.machine || '',
                pcba_acc: !!item.pcba_acc,
                fctry_acc: !!item.fctry_acc,
                service_acc: !!item.service_acc,
                fctry_param: item.fctry_param || '',
                pcba_param: item.pcba_param || '',
                remark: item.remark || ''
            };
            this.permission = item.permission.split(',');
            this.$refs.ptAccountSetting.show = true;
        },
        settingConfirm() {
            const params = {
                ...this.actData,
                // 后端这三个字段是 int，el-switch 绑定的是 bool，需转换为 0/1
                pcba_acc: this.actData.pcba_acc ? 1 : 0,
                fctry_acc: this.actData.fctry_acc ? 1 : 0,
                service_acc: this.actData.service_acc ? 1 : 0,
                // el-input type=number 绑定的是字符串，后端是 int
                dev_type: parseInt(this.actData.dev_type) || 0,
                permission: this.permission.join(',')
            };
            if(this.dialog.type == 'add') {
                this.api.ptAccount(params).then(data => {
                    this.actData = {};
                    this.$refs.ptAccountSetting.show = false;
                    this.getList();
                })
            }else{
                this.api.ptAccountUpdate(params).then(data => {
                    this.actData = {};
                    this.$refs.ptAccountSetting.show = false;
                    this.getList();
                })
            }

        }
    }
})
</script>
<style lang="less" scoped>
    
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/account/setting.vue